module.exports = __webpack_public_path__ + "static/media/YM34_6.4faf7f81.jpg";